const tasks = [
  {
    icon: 'ri-radar-line',
    title: 'Выявить зоны развития',
    desc: 'Понять, каких знаний, навыков и моделей поведения не хватает сотрудникам, чтобы выполнять работу на нужном уровне.',
  },
  {
    icon: 'ri-star-line',
    title: 'Определить сильные стороны',
    desc: 'Понять, на какие компетенции и сотрудников компания уже может опираться, а какие можно развивать дальше.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Сформировать кадровый резерв',
    desc: 'Выявить сотрудников с потенциалом для дальнейшего развития и продвижения на более ответственные роли.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Подготовить сотрудников к новой роли',
    desc: 'Определить готовность специалиста к позиции руководителя или расширению зоны ответственности.',
  },
  {
    icon: 'ri-book-read-line',
    title: 'Сформировать программы обучения',
    desc: 'Связать результаты оценки с конкретными направлениями обучения, а не обучать всех по одному шаблону.',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Повысить эффективность развития',
    desc: 'Не обучать всех одинаково, а направлять ресурсы туда, где они действительно необходимы.',
  },
  {
    icon: 'ri-dashboard-line',
    title: 'Поддержать управленческие решения',
    desc: 'Использовать результаты оценки при планировании развития сотрудников, команд и кадрового резерва.',
  },
];

export default function TasksSolved() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Какие задачи решает оценка сотрудников
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Оценка отвечает на конкретные вопросы бизнеса, а не превращается в формальную процедуру.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {tasks.map((t, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${t.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{t.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}